// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var projectRouter = {
  path: '/project',
  component: Layout,
  redirect: '/project/list',
  name: 'Project',
  meta: {
    title: '项目',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/project/list/index');
    },
    name: 'ProjectList',
    meta: {
      title: '项目管理',
      icon: ''
    }
  }, {
    path: 'group',
    component: function component() {
      return import('@/views/project/group/index');
    },
    name: 'ProjectGroupList',
    meta: {
      title: '项目组管理',
      icon: ''
    }
  }]
};
export default projectRouter;